// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.context {
    font-family: Arial, sans-serif;
    margin: 0;
    margin-top: 10%;
    padding: 0;
}

.contextTitle {
    font-size: 25px;
    font-weight: bolder;
    margin-top: 20px;
    text-align: center; /* 타이틀 가운데 정렬 */
}

.titleSeparator {
    max-width: 30%;
    border: none; /* 기본 테두리 제거 */
    height: 2px; /* 선의 두께 */
    background-color: #a7c898; /* 선의 색상 */
    margin-top: 15px; /* 제목과 선 사이의 여백 */
    margin-left: auto; /* 중앙 정렬 */
    margin-right: auto; /* 중앙 정렬 */
}

.listSeparator {
    max-width: 50%;
    border: none; /* 기본 테두리 제거 */
    height: 3px; /* 선의 두께 */
    background-color: rgb(255, 255, 255); /* 선의 색상 */
    margin-top: 10px;
    margin-bottom: 10px;
}

.sitemap {
    /*padding: 60px 500px; !* 좌우 패딩을 줄여서 가운데 정렬 *!*/
    margin-left: auto; /* 중앙 정렬 */
    margin-right: auto; /* 중앙 정렬 */
    font-family: Arial, sans-serif;
}

.sitemapTitle {
    font-weight: bold;
    text-align: center; /* 타이틀 가운데 정렬 */
}

.list-container {
    margin-bottom: 20px;
    width: 300px; /* 전체 너비를 차지하도록 설정 */
    min-width: 300px; /* 최대 너비 설정 */
    padding: 20px;
    background-color: rgba(167, 200, 152, 0.16); /* 배경색 */
    justify-content: center;
    align-items: center;
    text-align: center;
    border-radius: 8px; /* 둥근 모서리 */
    box-sizing: border-box;

}

.sitemap-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap; /* 항목이 줄 바꿈되도록 설정 */
    gap: 20px; /* 항목 간격 설정 */
    justify-content: center; /* 가운데 정렬 */

}

.sitemap-list li {
    /*flex: 1 1 calc(33.333% - 20px); !* 가로로 3개씩 배치, 20px는 gap을 고려 *!*/
    box-sizing: border-box; /* 패딩과 보더를 너비에 포함 */
    margin-bottom: 10px;
}

.sitemap-list ul {
    list-style-type: none;
    padding-left: 0;
}

.sitemap-list a {
    text-decoration: none;
    color: #636363;
}

.sitemap-list a:hover {
    color: #a7c898;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Sitemap/styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,UAAU;AACd;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB,EAAE,eAAe;AACvC;;AAEA;IACI,cAAc;IACd,YAAY,EAAE,cAAc;IAC5B,WAAW,EAAE,UAAU;IACvB,yBAAyB,EAAE,UAAU;IACrC,gBAAgB,EAAE,iBAAiB;IACnC,iBAAiB,EAAE,UAAU;IAC7B,kBAAkB,EAAE,UAAU;AAClC;;AAEA;IACI,cAAc;IACd,YAAY,EAAE,cAAc;IAC5B,WAAW,EAAE,UAAU;IACvB,oCAAoC,EAAE,UAAU;IAChD,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;IAC/C,iBAAiB,EAAE,UAAU;IAC7B,kBAAkB,EAAE,UAAU;IAC9B,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB,EAAE,eAAe;AACvC;;AAEA;IACI,mBAAmB;IACnB,YAAY,EAAE,oBAAoB;IAClC,gBAAgB,EAAE,aAAa;IAC/B,aAAa;IACb,2CAA2C,EAAE,QAAQ;IACrD,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB,EAAE,WAAW;IAC/B,sBAAsB;;AAE1B;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,SAAS;IACT,aAAa;IACb,eAAe,EAAE,mBAAmB;IACpC,SAAS,EAAE,aAAa;IACxB,uBAAuB,EAAE,WAAW;;AAExC;;AAEA;IACI,kEAAkE;IAClE,sBAAsB,EAAE,mBAAmB;IAC3C,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".context {\n    font-family: Arial, sans-serif;\n    margin: 0;\n    margin-top: 10%;\n    padding: 0;\n}\n\n.contextTitle {\n    font-size: 25px;\n    font-weight: bolder;\n    margin-top: 20px;\n    text-align: center; /* 타이틀 가운데 정렬 */\n}\n\n.titleSeparator {\n    max-width: 30%;\n    border: none; /* 기본 테두리 제거 */\n    height: 2px; /* 선의 두께 */\n    background-color: #a7c898; /* 선의 색상 */\n    margin-top: 15px; /* 제목과 선 사이의 여백 */\n    margin-left: auto; /* 중앙 정렬 */\n    margin-right: auto; /* 중앙 정렬 */\n}\n\n.listSeparator {\n    max-width: 50%;\n    border: none; /* 기본 테두리 제거 */\n    height: 3px; /* 선의 두께 */\n    background-color: rgb(255, 255, 255); /* 선의 색상 */\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.sitemap {\n    /*padding: 60px 500px; !* 좌우 패딩을 줄여서 가운데 정렬 *!*/\n    margin-left: auto; /* 중앙 정렬 */\n    margin-right: auto; /* 중앙 정렬 */\n    font-family: Arial, sans-serif;\n}\n\n.sitemapTitle {\n    font-weight: bold;\n    text-align: center; /* 타이틀 가운데 정렬 */\n}\n\n.list-container {\n    margin-bottom: 20px;\n    width: 300px; /* 전체 너비를 차지하도록 설정 */\n    min-width: 300px; /* 최대 너비 설정 */\n    padding: 20px;\n    background-color: rgba(167, 200, 152, 0.16); /* 배경색 */\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    border-radius: 8px; /* 둥근 모서리 */\n    box-sizing: border-box;\n\n}\n\n.sitemap-list {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-wrap: wrap; /* 항목이 줄 바꿈되도록 설정 */\n    gap: 20px; /* 항목 간격 설정 */\n    justify-content: center; /* 가운데 정렬 */\n\n}\n\n.sitemap-list li {\n    /*flex: 1 1 calc(33.333% - 20px); !* 가로로 3개씩 배치, 20px는 gap을 고려 *!*/\n    box-sizing: border-box; /* 패딩과 보더를 너비에 포함 */\n    margin-bottom: 10px;\n}\n\n.sitemap-list ul {\n    list-style-type: none;\n    padding-left: 0;\n}\n\n.sitemap-list a {\n    text-decoration: none;\n    color: #636363;\n}\n\n.sitemap-list a:hover {\n    color: #a7c898;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
